import { defineProperty as _defineProperty } from '../../_virtual/_rollupPluginBabelHelpers.js';
import React from 'react';
import { lsgPre } from '../../config/prefix.js';
import { cleanupClassObject } from '../../utils/DomUtils.js';
import { Host } from '../../utils/Host.js';
import { fComp } from '../../utils/React.js';
import { hostClass } from './PictureBackground.styles.js';

var defaultProps = {
  source: []
};
var PictureBackgroundPresentation = fComp(function (props) {
  var _cleanupClassObject;

  var id = props.id,
      children = props.children,
      className = props.className,
      noMargin = props.noMargin,
      isStencilHost = props.isStencilHost,
      backgroundFocalPoint = props.backgroundFocalPoint,
      style = props.style,
      viewportSource = props.viewportSource;
  var backgroundPosition;

  if (backgroundFocalPoint) {
    var offsetLeft = backgroundFocalPoint.offsetLeft,
        offsetTop = backgroundFocalPoint.offsetTop;
    backgroundPosition = "\n            ".concat(offsetLeft ? "left ".concat(offsetLeft, "%") : "", "\n            ").concat(offsetTop ? "top ".concat(offsetTop, "%") : "", "\n        ");
  }

  return /*#__PURE__*/React.createElement(Host, {
    id: id,
    className: cleanupClassObject((_cleanupClassObject = {}, _defineProperty(_cleanupClassObject, className, !!className), _defineProperty(_cleanupClassObject, hostClass, true), _defineProperty(_cleanupClassObject, "".concat(lsgPre, "no-margin"), noMargin), _cleanupClassObject)),
    isStencilHost: isStencilHost,
    style: Object.assign(Object.assign({}, style), {
      backgroundImage: viewportSource && "url(".concat(viewportSource, ")"),
      backgroundPosition: backgroundPosition,
      backgroundSize: "cover"
    })
  }, children);
}, defaultProps);

export { PictureBackgroundPresentation, defaultProps };
